import React, { useEffect, useState, useRef, Fragment } from "react";
import getCanales from "services/getCanales";
import CardCanales from "../cardCanales/cardCanales";
import Loading from "components/loading/loading";
import "./carrouselCanales.sass";


export default function CarrouselCanales({ chanelCode, activo, colorCanal, backgroundCanal, setLoad, elementos }) {
    const [dataEventos, setDataEventos] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [touchStart, setTouchStart] = useState(0);
    const [touchEnd, setTouchEnd] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [isEndReached, setIsEndReached] = useState(false);
    const sliderRef = useRef(null);
    const [loading, setLoading] = useState(true);
    const [newWidth, setNewWidth] = useState(0);
    const [showLoading, setShowLoading] = useState(true);
    //-- variables
    let ancho = 250;

    // peticion al servicio para obtener los eventos del calendario
    useEffect(() => {
        if (chanelCode) {
            getCanales(chanelCode)
                .then((canales) => {
                    if (canales && canales.entry) {
                        setDataEventos(canales.entry);
                    }
                    else {
                        setDataEventos([]);
                    }
                })
                .finally(() => {
                    setShowLoading(false);
                    setLoad(false);
                });
        }
    }, [chanelCode])

    const updateMobileStatus = () => {
        setNewWidth(window.innerWidth)
    };

    useEffect(() => {
        window.addEventListener('resize', updateMobileStatus);

        return () => {
            window.removeEventListener('resize', updateMobileStatus);
        };
    }, []);


    useEffect(() => {
        if (dataEventos && dataEventos.length !== 0) {
            setLoading(false);
        }
    }, [dataEventos])

    // desplazamiento del slider mediante gestos táctiles
    const handleSwipe = () => {
        if (((touchStart - touchEnd) > 100) && currentIndex < dataEventos.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }

        if (((touchEnd - touchStart) > 100) && currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    // inicio desplazamiento toch
    const handleTouchStart = (e) => {
        setTouchStart(e.targetTouches[0].clientX);
    };

    // desplazamiento touch en el eje x
    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    // click boton arrow left / right (desplazar a la izquierda y a la derecha)
    useEffect(() => {
        const handleScroll = () => {
            if (sliderRef.current) {
                setScrollLeft(sliderRef.current.scrollLeft);
            }

            const container = sliderRef.current;
            if (!container) return;

            let scrollLeft = container.scrollLeft;
            let containerWidth = container.clientWidth;
            let scrollWidth = container.scrollWidth;

            if ((scrollLeft + containerWidth) < (scrollWidth - 1))
                setIsEndReached(false);
            else
                setIsEndReached(true);
        };


        const currentSlider = sliderRef.current;
        if (currentSlider) {
            currentSlider.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (currentSlider) {
                currentSlider.removeEventListener('scroll', handleScroll);
                setNewWidth(currentSlider.clientWidth);
            }
        };
    }, [loading]);


    const moveScroll = (direction) => {
        const container = sliderRef.current;
        if (!container) return;

        const scrollLeftLocal = container.scrollLeft;
        const containerWidth = container.clientWidth;
        const itemWidth = container.querySelector('.container-card-chanel > *').clientWidth + 1;

        const itemsVisible = Math.floor(containerWidth / itemWidth);

        let move;
        if (direction === 'next') {
            let nextItemIndex = Math.ceil(scrollLeftLocal / itemWidth) + itemsVisible;
            move = nextItemIndex * itemWidth;
        } else {
            let prevItemIndex = Math.floor(scrollLeftLocal / itemWidth) - itemsVisible;
            move = prevItemIndex * itemWidth;
        }

        container.scrollTo({
            left: move,
            behavior: 'smooth'
        });
    };


    return (
        <>
            <div className={showLoading === false ? "envivo-component-carrousel" : "envivo-component-carrousel sliderNone"} >
                {showLoading && <Loading />}

                <div className={showLoading === false ? "container-slider-arrows" : "container-slider-arrows sliderNone"}  >
                    {scrollLeft >= 1 &&
                        <button className="arrowL" onClick={() => moveScroll("prev")}></button>
                    }

                    <div className="container-slider" ref={sliderRef}>
                        <div
                            className="slides"
                            onTouchStart={handleTouchStart}
                            onTouchMove={handleTouchMove}
                            onTouchEnd={handleSwipe}
                        >
                            {dataEventos && dataEventos.map((item, indice) =>
                                <Fragment key={indice}>
                                    <CardCanales
                                        imagen={item.extensions.preferredImage.uri}
                                        titulo={item.extensions.title}
                                        horaInicio={item.extensions.start_time}
                                        horaFin={item.extensions.end_time}
                                        enlace={item.url}
                                        colorFuente={colorCanal}
                                        colorFondo={backgroundCanal}
                                        activo={activo}
                                        elementos={elementos}
                                    />
                                </Fragment>
                            )}

                        </div>
                    </div>

                    {(!isEndReached && (((ancho * dataEventos.length) >= newWidth))) &&
                        <button className="arrowR" onClick={() => moveScroll("next")} ></button>
                    }
                </div>
            </div>
        </>
    )
}